export const LOADING_PURPOSE = "LOADING_PURPOSE";
export const SAVE_LOADING_PURPOSE = "SAVE_LOADING_PURPOSE";
export const GET_PURPOSE = "GET_PURPOSE";
export const FORM_FAIL = "FORM_FAIL";
export const PURPOSE_FAIL = "PURPOSE_FAIL";
export const LOADING_PURPOSE_BY_ID = "LOADING_PURPOSE_BY_ID";
export const GET_PURPOSE_BY_ID = "GET_PURPOSE_BY_ID";
